export default "__VITE_ASSET__BrcHeDff__"